import { toGameVariant, type ChallengeSettings } from '@draughts/shared';
import { useGameStore } from '../store/game-store';
import { trackGameStarted, trackFirstGameEver, trackVariantBreadth } from './analytics';
import { playSound } from './audio';

/**
 * Avvia una partita in presenza: due persone vere a QUESTO dispositivo, con le
 * opzioni scelte nella partita personalizzata.
 *
 * Vive fuori da App perche' e' l'anello in cui le impostazioni del foglio
 * diventano stato della partita, ed e' esattamente il punto in cui un valore puo'
 * perdersi per strada senza che niente si rompa a vista. Qui e' verificabile per
 * intero; ad App resta il cambio di schermata, che solo lei puo' fare.
 */
export function startInPersonGame(settings: ChallengeSettings): void {
  useGameStore.getState().startLocalGame(
    toGameVariant(settings.variant),
    'hotseat',
    settings.timeControl,
    {
      ruleMode: settings.gameMode,
      opening: settings.opening,
      // Il Bianco parte in basso: l'orientamento e' fisso, e in partita c'e' il
      // bottone per girare la damiera.
      color: 'white',
      // Andata e ritorno: lo store lo tiene solo con un'apertura sorteggiata,
      // che e' la stessa regola del foglio.
      legs: settings.legs,
    },
  );

  // Nessuna chiave: e' un gesto esplicito, non puo' arrivare in eco. Sul
  // perche' un suono chiamato «match-found» stia bene anche senza un
  // avversario da trovare, vedi la voce in `SOUNDS` (utils/audio.ts).
  playSound('match-found');
  trackGameStarted({
    variant: settings.variant,
    timeControl: settings.timeControl,
    mode: 'hotseat',
    ruleMode: settings.gameMode,
  });
  trackFirstGameEver('hotseat');
  trackVariantBreadth(settings.variant);
}
